import { Search as SearchIcon } from "react-bootstrap-icons";
import s from "./style.module.css";

export function SearchBar({ onChange }) {
  return (
    <>
      <SearchIcon size={25} className={s.icon} />
      <input
        onChange={onChange}
        className={s.input}
        type="text"
        placeholder="Search your notes..."
      />
    </>
  );
}
